import { useEffect } from "react";
import LegalLayout, { H2 } from "./LegalLayout";

/**
 * Términos de servicio — customer-facing.
 * Aclara que el rango de inversión es tentativo (no un precio en firme), el uso del
 * sitio, propiedad intelectual, consentimiento de comunicaciones y limitación.
 */
export default function Terms() {
  useEffect(() => {
    document.title = "Terms of Service · A Couple & A Dream";
  }, []);

  return (
    <LegalLayout title="Terms of Service" updated="July 16, 2026">
      <p>
        These Terms of Service govern your use of the website operated by A Couple &amp;
        A Dream, a brand of Javana Solutions LLC. By using this site or submitting a
        request, you agree to these terms.
      </p>

      <section className="space-y-3">
        <H2>Our service</H2>
        <p>
          A Couple &amp; A Dream is a residential design and construction studio serving
          Pinellas, Hillsborough, and Pasco counties in Florida. We design and build
          bathroom transformations under one roof.
        </p>
      </section>

      <section className="space-y-3">
        <H2>Tentative investment ranges</H2>
        <p>
          Any range shown by our online project builder is a tentative, informational
          range only. It is based on the selections you provide and is not a formal
          quote, offer, or guaranteed price. A firm proposal is provided only after an
          in-home design consultation, where we assess your specific space and scope.
        </p>
      </section>

      <section className="space-y-3">
        <H2>Consultations &amp; communications</H2>
        <p>
          When you request a consultation, you authorize us to contact you by phone,
          text, and email regarding your project. Scheduling a consultation does not
          create any obligation to move forward with a project. See our{" "}
          <a className="underline hover:text-clay" href="/privacy">
            Privacy Policy
          </a>{" "}
          for how we handle your information and your opt-out options.
        </p>
      </section>

      <section className="space-y-3">
        <H2>Intellectual property</H2>
        <p>
          All content on this site — including text, images, renderings, and design
          concepts — is the property of A Couple &amp; A Dream and may not be copied or
          reused without our written permission.
        </p>
      </section>

      <section className="space-y-3">
        <H2>Limitation of liability</H2>
        <p>
          This website and its content are provided &ldquo;as is,&rdquo; without
          warranties of any kind. To the fullest extent permitted by law, A Couple &amp;
          A Dream is not liable for any indirect or incidental damages arising from your
          use of the site or reliance on any tentative range shown.
        </p>
      </section>

      <section className="space-y-3">
        <H2>Contact us</H2>
        <p>
          Questions about these terms? Email{" "}
          <a className="underline hover:text-clay" href="mailto:hello@acouplenadream.com">
            hello@acouplenadream.com
          </a>
          .
        </p>
      </section>
    </LegalLayout>
  );
}
